export default [
    {
        path: '/mi-perfil',
        name: 'account-setting',
        component: () => import('@/views/account-setting/AccountSetting.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Mi perfil',
            breadcrumb: [
                {
                    text: 'Configuraciones',
                    active: true
                }
            ],
            requiresAuth: true
        }
    }
]